module.exports = __webpack_public_path__ + "img/content1.c9fb5411.png";